import React, { useCallback, useRef } from 'react';

import { useMatch } from 'react-router-dom';

import { IBaseProps } from '@rbi-ctg/frontend';
import { CustomEventNames, useMParticleContext } from 'state/mParticle';

import StyledLink from './styled-link';

interface INavLinkProps extends IBaseProps {
  to: string;
  requiresExactMatch?: boolean;
  onClick?: () => void;
  className?: string;
}

export const NavLink = ({
  requiresExactMatch,
  to,
  children,
  'data-testid': dataQaId,
  onClick,
  className = ''
}: INavLinkProps) => {
  const mParticle = useMParticleContext();
  const ref = useRef<HTMLAnchorElement | null>(null);

  const onClickAndLogToMParticle = useCallback(() => {
    const linkText = ref.current?.innerText;

    mParticle.logNavigationClick(CustomEventNames.NAV_CLICK, { linkText, linkTo: to });

    if (onClick) {
      onClick();
    }
  }, [mParticle, onClick, to]);

  const pathToMatch = requiresExactMatch ? to : `${to}/*`;
  const pathMatch = useMatch(pathToMatch);

  const activeClassName = pathMatch ? 'active' : '';

  return (
    <StyledLink
      to={to}
      onClick={onClickAndLogToMParticle}
      className={`${className} ${activeClassName}`}
      data-testid={dataQaId}
      ref={ref}
    >
      {children}
    </StyledLink>
  );
};

export const iconSize = 25;
